import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { DateTime } from 'luxon';

import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';
import { SelectComponent } from '../select/select.component';

@Component({
    selector: 'lib-date-of-birth-selector',
    standalone: true,
    imports: [CommonModule, SelectComponent, InputWrapperComponent, ReactiveFormsModule],
    templateUrl: './date-of-birth-selector.component.html',
    styleUrl: './date-of-birth-selector.component.css'
})
export class DateOfBirthSelectorComponent implements OnInit {
    /* eslint-disable */
    @Input() ionItemWrap: boolean = true;
    @Input() label: string = '';
    @Input() initialYear: string = '';
    @Input() initialMonth: string = '';
    @Input() initialDay: string = '';

    @Input() disabled: boolean = false;
    @Input() required: boolean = false;

    @Input() errorText: string | undefined;

    @Output() onDateSelect = new EventEmitter();

    days: Array<{ label: string; value: string }> = [];
    months: Array<{ label: string; value: string }> = [];
    years: Array<{ label: string; value: string }> = [];

    yearsMin = DateTime.now().year - 100;
    yearsMax = DateTime.now().year;

    monthsMin = 1;
    monthsMax = 12;

    daysMin = 1;
    daysMax = 31;

    selectedYear = '';
    selectedMonth = '';
    selectedDay = '';

    form: FormGroup = new FormGroup({
        day: new FormControl('', Validators.required),
        month: new FormControl('', Validators.required),
        year: new FormControl('', Validators.required)
    });

    constructor() {}

    ngOnInit(): void {
        const years = this.getArrayFromNumbers(this.yearsMin, this.yearsMax);
        const months = this.getArrayFromNumbers(this.monthsMin, this.monthsMax);
        const days = this.getArrayFromNumbers(this.daysMin, this.daysMax);

        this.years = this.formattedForSelectOptions(years).reverse();
        this.months = this.formattedForSelectOptions(months);
        this.days = this.formattedForSelectOptions(days);

        this.form.patchValue({
            year: this.initialYear || '',
            month: this.initialMonth || '',
            day: this.initialDay || ''
        });

        if (this.disabled) {
            this.form.disable();
        }
    }

    markAllAsTouched() {
        this.form.markAllAsTouched();
    }

    resetForm() {
        this.form.patchValue({
            year: this.initialYear || '',
            month: this.initialMonth || '',
            day: this.initialDay || ''
        });
        this.form.markAsPristine();
    }

    onSelectChange(event: string, type: 'year' | 'month' | 'day') {
        console.log(event);
        this.errorText = undefined;

        if (type === 'year') {
            this.selectedYear = event;
        } else if (type === 'month') {
            this.selectedMonth = event;
        } else if (type === 'day') {
            this.selectedDay = event;
        }

        if (this.selectedYear && this.selectedMonth && this.selectedDay) {
            this.onDateSelect.emit(`${this.selectedYear}-${this.selectedMonth}-${this.selectedDay}`);
        } else {
            this.onDateSelect.emit(null);
        }
    }

    getArrayFromNumbers(min: number, max: number) {
        return Array(max - min + 1)
            .fill(min)
            .map((n, i) => {
                return n + i;
            });
    }

    formattedForSelectOptions(array: number[]) {
        return array.map(number => {
            const value = number.toString().padStart(2, '0');
            return {
                label: value,
                value: value
            };
        });
    }
}
